import React from "react";

import { ReactComponent as DownloadIcon } from "../../../../assets/icons/Sample Submission Redesign/download.svg";
import { ReactComponent as PrintIcon } from "../../../../assets/icons/Sample Submission Redesign/print.svg";
import { ReactComponent as InfoIcon } from "../../../../assets/icons/Sample Submission Redesign/print-info.svg";

import "./ReceiptModalActionsBar.css";

export default function ReceiptModalActionsBar({
  loading, handlePrint, handleDownload, closable, headerTitleText,
}) {
  const textSuffix = headerTitleText ? "--with-title" : "";
  const barSuffix = closable ? "--closable" : "";

  return (
    <div className={`ReceiptModalActionsBar${barSuffix}`}>
      <div className={`ReceiptModalActionsBar__Text${textSuffix}`}>
        {headerTitleText && <span className="ReceiptModalActionsBar__Title">{headerTitleText}</span>}
        <span className="ReceiptModalActionsBar__Info">
          <InfoIcon className="ReceiptModalActionsBar__InfoIcon" width={14} height={14} aria-hidden />
          Print out this receipt and include it with the sample contents in your package.
        </span>
      </div>
      <div className="SubmissionReceiptModal__Buttons">
        <button
          type="button"
          className="ReceiptModalActionsBar__IconButton"
          disabled={loading}
          aria-label="Download receipt"
          onClick={handleDownload}
        >
          <DownloadIcon aria-hidden />
        </button>
        <button
          type="button"
          className="ReceiptModalActionsBar__IconButton"
          disabled={loading}
          aria-label="Print receipt"
          onClick={handlePrint}
        >
          <PrintIcon aria-hidden />
        </button>
      </div>
    </div>
  );
}
